<template>
    <Dropdown
        :options="filteredProducts"
        placeholder="-- selecteer een product --"
        :max-item="30"
        @filter="onFilter"
        @selected="onSelected"
    ></Dropdown>
</template>

<script>
    import _ from 'lodash';
    import Dropdown from 'vue-simple-search-dropdown';

    export default {
        components: {
            Dropdown,
        },
        data() {
            return {
                selectedProductId: null,
                filteredProducts: [],
            };
        },
        props: {
            products: {
                type: Array,
                default: function () {
                    return [];
                },
            },
            selected: {
                type: Number,
                default: null,
            },
        },
        computed: {
            id() {
                return this.randomString();
            },
        },
        watch: {
            products: {
                immediate: true,
                handler() {
                    this.filteredProducts = this.products;
                },
            },
            selected: {
                immediate: true,
                handler() {
                    this.selectedProductId = this.selected;
                },
            },
        },
        created() {
            if (!this.filteredProducts || this.filteredProducts.length === 0) {
                this.getProducts();
            }
        },
        methods: {
            getProducts(searchTerm = null) {
                this.filteredProducts = [];

                axios
                    .get('/api/products', {
                        params: {
                            search: searchTerm,
                        },
                    })
                    .then(response => {
                        this.filteredProducts = response.data.result.data.map(product => {
                            return {
                                id: product.id,
                                name: product.number + ': ' + product.name,
                            };
                        });
                    })
                    .catch(error => {
                        this.globalVars.globalError = this.createErrorFromRequest(error);
                    })
                ;
            },

            onFilter: _.debounce(function (searchTerm) {
                this.getProducts(searchTerm);
            }, 500),
            onSelected(event) {
                this.selectedProductId = event.id;

                this.$emit('update:selected', this.selectedProductId)
            },
        },
    };
</script>
